import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./allRoutes";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
import AuthProtected from "./AuthProtected";
import ProtectedRoute from "./moduleProtectedRoutes";

const Index = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<NonAuthLayout />}>
        {publicRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.component} />
        ))}
      </Route>

      {/* Protected Routes */}
      <Route
        element={
          <AuthProtected>
            <VerticalLayout />
          </AuthProtected>
        }
      >
        {authProtectedRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <ProtectedRoute constant={route.constant}>
                {route.component}
              </ProtectedRoute>
            }
          />
        ))}

        {/* Redirects */}
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
};

export default Index;
